import React from 'react'
import ReactDOM from 'react-dom/client'
import './utils/api' // Configure axios defaults early
import App from './App.tsx'
import './style.css'

ReactDOM.createRoot(document.getElementById('app')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
